import CloseIcon from '@mui/icons-material/Close';
import {IconButton} from '@mui/material';
import React, {useEffect, useRef} from 'react';
import './styles.css';

export const Modal = ({active, setActive, children, disabled_dismiss}) => {
  // AUTO CLOSE MODAL
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (disabled_dismiss) {
        return;
      }
      if (modalRef.current && event.target === modalRef.current) {
        setActive(false);
      }
    }

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [setActive, disabled_dismiss, modalRef]);

  return (
    <div ref={modalRef} className={`modal ${active ? 'show-modal' : ''}`}>
      <div className="modal-content">
        <IconButton
          aria-label="close"
          onClick={() => setActive(false)}
          style={{position: 'absolute', top: 12, right: 12, zIndex: 1}}>
          <CloseIcon />
        </IconButton>
        {children}
      </div>
    </div>
  );
};
